import { render } from "./order-fulfillment.vue?vue&type=template&id=1414e37c&scoped=true"
import script from "./order-fulfillment.vue?vue&type=script&lang=js"
export * from "./order-fulfillment.vue?vue&type=script&lang=js"

import "./order-fulfillment.vue?vue&type=style&index=0&id=1414e37c&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1414e37c"]])

export default __exports__